import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const updateVehicle = async ({ vehicle_id, data }: any) => {
  const result = await fetch(`${REACT_APP_VMS_BASE_URL}/vehicles/${vehicle_id}`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  const vehicles = await result.json();
  return vehicles;
};

export default updateVehicle;
